<script lang="ts">
	interface TimeInputProps {
		hours: string
		minutes: string
		period: string
		onChange?: () => void
		label?: string
		use24HourFormat?: boolean
	}

	let {
		hours = $bindable(''),
		minutes = $bindable(''),
		period = $bindable(''),
		onChange = () => {},
		label = '',
		use24HourFormat = false
	}: TimeInputProps = $props()

	const hoursOptions = $derived(
		use24HourFormat
			? Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))
			: Array.from({ length: 12 }, (_, i) => String(i === 0 ? 12 : i).padStart(2, '0'))
	)

	const minutesOptions = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'))
</script>

<div class="time-input">
	{#if label}
		<div class="mb-1 text-sm text-[#001D33B2]">{label}</div>
	{/if}
	<div class="fields-wrapper flex items-center space-x-2">
		<div class="select-wrapper">
			<select bind:value={hours} onchange={onChange} class="time-select">
				{#each hoursOptions as hour}
					<option value={hour}>{hour}</option>
				{/each}
			</select>
		</div>
		<span class="text-[#001D33B2]">:</span>
		<div class="select-wrapper">
			<select bind:value={minutes} onchange={onChange} class="time-select">
				{#each minutesOptions as minute}
					<option value={minute}>{minute}</option>
				{/each}
			</select>
		</div>
		{#if !use24HourFormat}
			<div class="select-wrapper period-select">
				<select bind:value={period} onchange={onChange} class="time-select">
					<option value="AM">AM</option>
					<option value="PM">PM</option>
				</select>
			</div>
		{/if}
	</div>
</div>

<style>
	.time-input {
		width: 100%;
	}

	.select-wrapper {
		@apply relative flex-1 h-10 border border-[#002c4d80] rounded-lg bg-white overflow-hidden transition-[border-color] duration-200;
	}

	.select-wrapper:hover {
		@apply border-[#007acc];
	}

	.period-select {
		@apply min-w-[70px];
	}

	.time-select {
		@apply w-full h-full px-2 border-none bg-transparent appearance-none cursor-pointer text-[0.9rem] text-[#001626e5] outline-none;
	}

	.select-wrapper::after {
		content: '';
		@apply absolute top-1/2 right-[10px] -translate-y-1/2 w-0 h-0 pointer-events-none;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid #002c4d80;
	}

	.fields-wrapper {
		@apply flex items-center space-x-2;
	}
</style>
